const grid = {
  numberVariationsMobile: 7,
  numberVariationsDesktop: 8,
  counter: 10
};

export default grid;
